<input
  (blur)="onTouched()"
  (ngModelChange)="onValueChange($event)"
  [class.number-input--error]="control.touched && control.invalid"
  [disabled]="isDisabled"
  [id]="name"
  [ngModel]="value"
  [placeholder]="placeholder"
  class="number-input"
  type="number"
/>

<wp-input-error *ngIf="control.touched && control.invalid">
  <ng-content></ng-content>
</wp-input-error>
